export default __webpack_public_path__ + "static/media/tokennomics.ab1659b8.png";